import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFDownloadLink,
  Link,
  Image,
} from "@react-pdf/renderer";

import sbimg from "./sbimg.png";

// Create Document Component
export const MyDocument = ({props,imageFile}) => (
     props ?(
  <Document>
    <Page size={"A4"}>
      <View style={{ padding: "10px" }}>
        <View
          style={{
            border: "3px solid black",
            padding: "10px",
            borderRadius: "5px",
          }}
        >
          <View
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              border: "2px solid black",
              fontWeight: "bold",
              borderRadius: "5px",
            }}
          >
            <View style={{ display: "flex", flexDirection: "row" }}>
              <Image
                style={{ width: "30px", marginRight: "10px" }}
                src={sbimg}
              />
              <Text style={{ fontSize: 20, fontWeight: "bold" }}>
                SB Pathshala
              </Text>
            </View>

            <View>
              <Link href="https://www.sbpathshala.com/">
                www.sbpathshala.com
              </Link>
            </View>
          </View>
          <View>
            <View
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",

                fontWeight: "bold",
              }}
            >
              <Text>Scholarship Test</Text>
              <Text>Admit Card</Text>
            </View>
          </View>
          <View style={{ border: "2px solid black", padding: "10px" }}>
            <View
              style={{ display: "flex", flexDirection: "row", width: "100%" }}
            >
              <View style={{ width: "80%", height: "120px" }}>
                <View
                  style={{
                    width: "100%",
                    border: "2px solid black",
                    paddingLeft: "10px",
                    flexDirection: "row",
                    height: "30px",
                    marginTop: "2px",
                    borderRadius: "5px",
                  }}
                >
                  <Text
                    style={{ width: "50%", borderRight: "2px solid black" }}
                  >
                   Registration Number
                  </Text>
                  <Text style={{ paddingLeft: "3px" }}>{props.registrationno ? props.registrationno : "N/A"}</Text>
                </View>
                <View
                  style={{
                    width: "100%",
                    border: "2px solid black",
                    paddingLeft: "10px",
                    flexDirection: "row",
                    height: "30px",
                    marginTop: "2px",
                    borderRadius: "5px",
                  }}
                >
                  <Text
                    style={{ width: "50%", borderRight: "2px solid black" }}
                  >
                    Name
                  </Text>
                  <Text style={{ paddingLeft: "3px" }}>{props.name ? props.name : "N/A"}</Text>
                </View>
                <View
                  style={{
                    width: "100%",
                    border: "2px solid black",
                    paddingLeft: "10px",
                    flexDirection: "row",
                    height: "30px",
                    marginTop: "2px",
                    borderRadius: "5px",
                  }}
                >
                  <Text
                    style={{ width: "50%", borderRight: "2px solid black" }}
                  >
                    Gender
                  </Text>
                  <Text style={{ paddingLeft: "3px" }}>{props.gender}</Text>
                </View>
                <View
                  style={{
                    width: "100%",
                    border: "2px solid black",
                    paddingLeft: "10px",
                    flexDirection: "row",
                    height: "30px",
                    marginTop: "2px",
                    borderRadius: "5px",
                  }}
                >
                  <Text
                    style={{ width: "50%", borderRight: "2px solid black" }}
                  >
                    Date Of Birth
                  </Text>
                  <Text style={{ paddingLeft: "3px" }}>{props.dateofbirth ? props.dateofbirth : "N/A"}</Text>
                </View>
              </View>
              <View style={{ width: "20%", height: "120px" }}>
                <Image
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "1px solid black",
                    borderRadius: "10px",
                  }}
                  src={imageFile}
                />
              </View>
            </View>

            <View
              style={{
                width: "100%",
                border: "2px solid black",
                paddingLeft: "10px",
                flexDirection: "row",
                marginTop: "2px",
                borderRadius: "5px",
              }}
            >
              <Text style={{ width: "40%", borderRight: "2px solid black" }}>
                Father Name
              </Text>
              <Text style={{ paddingLeft: "3px" }}>{props.fathername ? props.fathername : "N/A"}</Text>
            </View>
            <View
              style={{
                width: "100%",
                border: "2px solid black",
                paddingLeft: "10px",
                flexDirection: "row",
                borderRadius: "5px",
              }}
            >
              <Text style={{ width: "40%", borderRight: "2px solid black" }}>
                Address
              </Text>
              <View style={{ flex: 1, paddingLeft: "3px", flexWrap: "wrap" }}>
                <Text>{props.address
    ? `${props.address.village || ''} ${props.address.post || ''} ${props.address.pincode || ''}`
    : 'N/A'}</Text>
              </View>
            </View>

            <View
              style={{
                width: "100%",
                border: "2px solid black",
                paddingLeft: "10px",
                flexDirection: "row",
                height: "30px",
                marginTop: "2px",
                borderRadius: "5px",
              }}
            >
              <Text style={{ width: "40%", borderRight: "2px solid black" }}>
                Mobile No
              </Text>
              <Text style={{ paddingLeft: "3px" }}>{props.mobileno ? props.mobileno : "N/A"}</Text>
            </View>
            <View
              style={{
                width: "100%",
                border: "2px solid black",
                paddingLeft: "10px",
                flexDirection: "row",
                height: "30px",
                marginTop: "2px",
                borderRadius: "5px",
              }}
            >
              <Text style={{ width: "40%", borderRight: "2px solid black" }}>
                Exam Date & Time
              </Text>
              <Text style={{ paddingLeft: "3px" }}>25-12-23(1pm-3pm)</Text>
            </View>
            <View
              style={{
                width: "100%",
                border: "2px solid black",
                paddingLeft: "10px",
                flexDirection: "row",
                marginTop: "2px",
                borderRadius: "5px",
              }}
            >
              <Text style={{ width: "40%", borderRight: "2px solid black" }}>
                Exam Center Address
              </Text>
              <Text style={{ flex: 1, paddingLeft: "3px", flexWrap: "wrap" }}>Adarsh Children Academy BhramChari Tola station-road Ghogha Pincode-813205</Text>
            </View>
            <View
              style={{
                width: "100%",
                border: "2px solid black",
                paddingLeft: "10px",
                flexDirection: "row",
                height: "30px",
                marginTop: "2px",
                borderRadius: "5px",
              }}
            >
              <Text style={{ width: "40%", borderRight: "2px solid black" }}>
                PaymentId
              </Text>
              <Text style={{ paddingLeft: "3px" }}>{props.paymentid ? props.paymentid : "N/A"}</Text>
            </View>
            <View
              style={{
                width: "100%",
                border: "2px solid black",
                paddingLeft: "10px",
                flexDirection: "row",
                height: "30px",
                marginTop: "2px",
                borderRadius: "5px",
              }}
            >
              <Text style={{ width: "40%", borderRight: "2px solid black" }}>
               Fees
              </Text>
              <Text style={{ paddingLeft: "3px" }}>{props.fees ? props.fees : "N/A"}</Text>
            </View>
            <View
              style={{
                width: "100%",
                border: "2px solid black",
                paddingLeft: "10px",
                flexDirection: "row",
                height: "30px",
                marginTop: "2px",
                borderRadius: "5px",
              }}
            >
              <Text style={{ width: "40%", borderRight: "2px solid black" }}>
                Subjects
              </Text>
              <Text style={{ paddingLeft: "3px" }}>
                Math , Physics , Chemistry
              </Text>
            </View>
          </View>
          <View
            style={{
              width: "100%",
              border: "2px solid black",
              paddingLeft: "10px",
              height: "50px",
              marginTop: "10px",
            }}
          >
            <Text
              style={{
                width: "40%",
                borderRight: "2px",
                height: "50px",
                justifyContent: "center",
                alignItems: "center",
                paddingTop: "20px",
              }}
            >
              Examiner Signature
            </Text>
          </View>
          <View
            style={{
              width: "100%",

              marginTop: "10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text>More details visit website www.sbpathshala.com </Text>
          </View>
        </View>
        <View
          style={{
            width: "100%",
            border: "2px solid black",
            paddingLeft: "10px",
            height: "auto", // Adjusted to allow dynamic height based on content
            marginTop: "10px",
            borderRadius: "5px",
          }}
        >
          <View
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Text style={{ fontWeight: "bold", marginBottom: 5 }}>
              Our Coaching Center Benefits And Facilities
            </Text>
          </View>
          <View>
            <Text>
              &bull; Expert guidance for JEE Main, NEET, 11th, 12th, and Bihar
              Board exams
            </Text>
            <Text>&bull; Specialized coaching for CSBC exams</Text>
            <Text>
              &bull; Interactive speaking classes to enhance communication
              skills
            </Text>
            <Text>
              &bull; Well-equipped computer classes for practical learning
            </Text>
            <Text>
              &bull; Comfortable hostel facilities for outstation students
            </Text>
            <Text>&bull; Access to the best teachers in the field</Text>
          </View>
        </View>
      </View>
    </Page>
  </Document>
    )
  :<></>

        
);
